module.exports = __webpack_public_path__ + "img/reacondicionarte.834a4250.jpg";